export const PROJECT = 'PROJECT'